import { render, staticRenderFns } from "./pc-page-right-1.vue?vue&type=template&id=847c219a&scoped=true"
import script from "./pc-page-right-1.vue?vue&type=script&lang=js"
export * from "./pc-page-right-1.vue?vue&type=script&lang=js"
import style0 from "./pc-page-right-1.vue?vue&type=style&index=0&id=847c219a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847c219a",
  null
  
)

export default component.exports